import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  LabelList
} from "recharts";

const data = [
  {
    name: "2022",
    โท: 8,
    เอกฐานตรี: 3,
    เอกฐานโท: 9,
    target2: 25,
    target3: 10
  },
  {
    name: "2023",
    โท: 6,
    เอกฐานตรี: 0,
    เอกฐานโท: 9,
    target2: 25,
    target3: 10
  },
  {
    name: "2024",
    โท: 9,
    เอกฐานตรี: 0,
    เอกฐานโท: 6,
    target2: 25,
    target3: 10
  }
].map(entry => ({
  ...entry,
  total: entry.โท + entry.เอกฐานตรี + entry.เอกฐานโท
}));

const Mixchart = () => {
  const InsideLabel = ({ x, y, value, width }) => {
    if (!value || value <= 0) return null;
    return (
      <text
        x={x + width / 2}
        y={y + 11} // ตำแหน่งภายใน bar
        fill="white"
        textAnchor="middle"
        fontSize={12}
      >
        {value}
      </text>
    );
  };

  return (
    <React.Fragment>
      <ResponsiveContainer width="100%" height={210}>
        <BarChart
          width={500}
          height={300}
          data={data}
          margin={{
            top: 20,
            right: 30,
            left: 20,
            bottom: 5
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar dataKey="โท" stackId="a" fill="#8884d8">
            <LabelList dataKey="โท" content={<InsideLabel />} />
          </Bar>
          <Bar dataKey="เอกฐานตรี" stackId="a" fill="#82ca9d">
            <LabelList dataKey="เอกฐานตรี" content={<InsideLabel />} />
          </Bar>
          <Bar dataKey="เอกฐานโท" stackId="a" fill="#ffc658">
            <LabelList dataKey="total" position="top" />
            <LabelList dataKey="เอกฐานโท" content={<InsideLabel />} />
          </Bar>
          <Bar name="เป้าหมาย ป.โท" dataKey="target2" fill="#c3c479">
            <LabelList dataKey="target2" position="top" />
          </Bar>
          <Bar name="เป้าหมาย ป.เอก" dataKey="target3" fill="#96977c">
            <LabelList dataKey="target3" position="top" />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </React.Fragment>
  );
};
export default Mixchart;
